import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faEdit,
  faTrashAlt,
  faLocationArrow,
  faBox,
  faInfo,
  faClock,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import BocomboForm from "./BocomboForm";
import { ModalStyle, ModalStyleFull } from "./Style";
import { getEnvironment } from "./Environment";
import {useSortable} from '@dnd-kit/sortable';
import {CSS} from '@dnd-kit/utilities';

library.add(faEdit);
library.add(faTrashAlt);
library.add(faLocationArrow);
library.add(faBox);
library.add(faInfo);
library.add(faClock);
library.add(faUser);

const BocomboTask = ({ task, editTask, handleToggle, handleDelete }) => {
   const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({id: task.id});

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };
  

  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
 
  const handlePointerDown = (e) => {
    // console.log("Pointer down");
    setIsDragging(false);

    // Verhindern, dass Edit / Delete Buttons das Toggle auslösen
    if (e.target.closest('.task_options')) {
      return;
    }

    listeners.onPointerDown(e);
  };

  const handlePointerMove = (e) => {
    // console.log("Pointer move");
    setIsDragging(true);
  };

  const handlePointerUp = (e) => {
    // console.log("Click event, isDragging:", isDragging);
    // Nur toggle wenn nicht gedraggt wurde
    if (isDragging) {
      setIsDragging(false);
      return;
    }

    // Verhindern, dass Edit / Delete Buttons das Toggle auslösen
    if (e.target.closest('.task_options')) {
      return;
    }

    handleToggle(e.currentTarget.id);
  };

  const handleEditLink = (e) => {
    e.stopPropagation();
    setShowEditModal(true);
  };
  const handleDeleteLink = (e) => {
    e.stopPropagation();
    setShowDeleteModal(true);
  };

  const handleDeleteClose = () => {
    setShowDeleteModal(false);
  };

  const handleEditClose = () => {
    setShowEditModal(false);
  };

  const handleDeleteCall = () => {
    handleDelete(task.id);
  };

  const addTask = (userInput, location, resolution, explanation, topic) => {
    editTask(task.id, userInput, location, resolution, explanation, topic);
    setShowEditModal(false);
  };

  const env = getEnvironment();

  let icon1 =
    env.language && env.language.icon1
      ? env.language && env.language.icon1
      : "location-arrow";

  let icon2 =
    env.language && env.language.icon2
      ? env.language && env.language.icon2
      : "box";

  let icon0 =
    env.language && env.language.icon0
      ? env.language && env.language.icon0
      : "box";

  return (
    <>
      <Modal
        open={showDeleteModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={ModalStyle}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Element entfernen?
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <div style={{ paddingBottom: `20px` }}>
              Soll das Element "{task.task}" entfernt werden?
            </div>
            <Button variant="contained" onClick={handleDeleteCall}>
              Ja
            </Button>
            <Button variant="outline" onClick={handleDeleteClose}>
              Nein
            </Button>
          </Typography>
        </Box>
      </Modal>

      <Modal
        open={showEditModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={ModalStyleFull}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Editieren
          </Typography>
          <BocomboForm
            addTask={addTask}
            initValues={task}
            textAreaWidth="100%"
          />
          <Button variant="outline" onClick={handleEditClose}>
            Abbrechen
          </Button>
        </Box>
      </Modal>

      <div
        ref={setNodeRef} style={style} {...attributes} {...listeners}
        id={task.id}
        key={task.id + "task"}
        name="task"
        value={task.id}

        onPointerDown={handlePointerDown}
        onPointerMove={handlePointerMove}
        onPointerUp={handlePointerUp}

        className={task.complete ? "strike task" : "task"}
      >
        <div
          className="task_topic"
          style={{
            paddingTop: `5px`,
            display:
              typeof task.topic === "undefined" || task.topic === ""
                ? "none"
                : "",
          }}
        >
          {task.topic}
        </div>

        <div
          className="task_explanation"
          style={{
            paddingTop: `5px`,
            display:
              typeof task.explanation === "undefined" || task.explanation === ""
                ? "none"
                : "",
          }}
        >
          {task.explanation}
        </div>

        <div className={"task_task_hovered task_title"}>
          <span
            style={{
              width: `24px`,
              display: `inline-block`,
              textAlign: `center`,
            }}
          >
            <FontAwesomeIcon icon={icon0} style={{ paddingRight: `5px` }} />
          </span>
          {task.task}
        </div>
        <div
          className="task_location"
          style={{
            paddingTop: `5px`,
            display:
              typeof task.location === "undefined" || task.location === ""
                ? "none"
                : "",
          }}
        >
          <span
            style={{
              width: `24px`,
              display: `inline-block`,
              textAlign: `center`,
            }}
          >
            <FontAwesomeIcon icon={icon1} style={{ paddingRight: `5px` }} />
          </span>
          {task.location}
        </div>

        <div
          className="task_resolution"
          style={{
            paddingTop: `5px`,
            display:
              typeof task.resolution === "undefined" || task.resolution === ""
                ? "none"
                : "",
          }}
        >
          <span
            style={{
              width: `24px`,
              display: `inline-block`,
              textAlign: `center`,
            }}
          >
            <FontAwesomeIcon icon={icon2} style={{ paddingRight: `5px` }} />
          </span>
          {task.resolution}
        </div>

        <div
          className="task_options"
          // style={{ display: hovered ? "" : "none" }}
        >
          <span onClick={handleEditLink} style={{ padding: '8px 12px', cursor: 'pointer' }}>
            <FontAwesomeIcon icon="edit" /> Editieren
          </span>
          <span onClick={handleDeleteLink} style={{ padding: '8px 12px', cursor: 'pointer' }}>
            <FontAwesomeIcon icon="trash-alt" /> Löschen
          </span>
        </div>
      </div>
    </>
  );
};

export default BocomboTask;
